import User from "../../js/waglebagle/Object/user";
import Common from "../../js/waglebagle/common";
import Validator from "../../js/waglebagle/validator";

const MyInfo = ((Vd, User) => {
    const $bntEmailChk = $("#emailchk");
    const $btnSubmit = $("#btn_submit");
    const $btnResendEmail = $("#btn_resend_email");

    const $inputEmail = $("#user_email");
    const $inputRealname = $("input[name=realname]");

    const $myForm = $("#my_form");

    let me = {};

    // 이메일 중복확인 여부
    let chkEmail = true;
    let saved = true;

    function init() {
        me = new User(Common.serializeObject($myForm));

        $("#user_email").on("keyup", e => {
            chkEmail = false;
        });

        $btnResendEmail.on("click", e => {
            e.preventDefault();

            if (chkEmail === false) {
                alert("이메일 중복확인을 해주시기 바랍니다.");
                return;
            } else if (saved === false) {
                alert("변경 내용을 저장하여 주시기 바랍니다.");
                return;
            }

            resendEmail();
        });

        $bntEmailChk.on("click", e => {
            e.preventDefault();

            checkDuplEmail.call(this, $inputEmail.val());
        });

        $inputRealname.on("blur", e => {
            if (!Validator.validateRealname($inputRealname.val())) {
                alert("이름을 바르게 입력하여 주시기 바랍니다.");
            } else {
                me.setRealname($inputRealname.val());
            }
        });

        $btnSubmit.on("click", e => {
            e.preventDefault();

            const children = [];

            for (let i = 0; i < $(".child_form").length; i++) {
                let child = {};
                let $currentChild = $(".child_form").eq(i);
                let name = $currentChild.find("input[name=c_name]").val();
                if (!name) {
                    continue;
                }
                child.name = name;
                child.sex = $currentChild
                    .find("input[name^=c_sex]:checked")
                    .val();
                child.birthdate = $currentChild
                    .find(".c_birth")
                    .map(function(i, v) {
                        return v.value;
                    })
                    .get()
                    .join("-");

                children.push(child);
            }

            me.setPhone(makePhoneStr());
            me.setBirthday(makeBirthStr());
            me.setPostCode($("#post_code").val());
            me.setUserAddress($("#user_address").val());
            me.setUserAddressEtc($("#user_address_etc").val());
            me.setChildren(children);

            updateMyInfo(me);
        });
    }

    function resendEmail() {
        $.ajax("//www.waglebagle.net/mypage/_proc/ajax_proc.inc", {
            type: "POST",
            data: {
                mode: "resend_cert_mail"
            }
        }).then(res => {
            console.log(res);
            let result = JSON.parse(res);

            alert(result.message);
        });
    }

    function makeBirthStr() {
        return $(".birth")
            .map(function(i, v) {
                return v.value;
            })
            .get()
            .join("-");
    }

    function makePhoneStr() {
        return $(".m_phone")
            .map(function(i, v) {
                return v.value;
            })
            .get()
            .join("-");
    }

    function updateMyInfo(mydata) {
        if (chkEmail === false) {
            alert("이메일 중복확인을 해주시기 바랍니다.");
            return;
        }

        $.ajax("//www.waglebagle.net/mypage/_proc/ajax_proc.inc", {
            type: "POST",
            data: {
                mode: "update_myinfo",
                user: mydata
            }
        }).then(res => {
            const result = JSON.parse(res);
            if (result.success === true) {
                alert("정보 수정이 완료되었습니다.");
                saved = true;
                location.href = "/";
            } else {
                alert(result.message);
            }
        });
    }

    function checkDuplEmail(email) {
        return $.ajax("//www.waglebagle.net/mypage/_proc/ajax_proc.inc", {
            type: "POST",
            data: {
                mode: "check_dupl_email",
                email: email
            }
        }).then(res => {
            const result = JSON.parse(res);
            if (result.success === true) {
                chkEmail = true;
                saved = false;
            } else {
                chkEmail = false;
                $inputEmail.focus();
            }

            me.setEmail(email);

            alert(result.message);
        });
    }

    return {
        init
    };
})(Validator, User);

$(document).ready(() => {
    MyInfo.init();
});



// WEBPACK FOOTER //
// ./mypage/js/myinfo.js